<template>
  <b-tabs
    :value="value"
    position="is-centered"
    size="is-small"
    expanded
    @input="$emit('input', $event)"
  >
    <slot></slot>
  </b-tabs>
</template>

<script>
export default {
  name: "TabsMobile",
  props: {
    value: {
      type: String | Number
    }
  },
};
</script>

<style lang="scss" scoped>

::v-deep {

  .tabs {
    margin-bottom: 10px;
  }

  .tabs li.is-active a {
    border-bottom-color: #1C6C7D;
    color: #1C6C7D;
  }

  .tabs a {
    border-width: 4px;
    padding: 0.25rem 0.5rem 0.5rem;
    line-height: 18px;
  }
}
</style>
